export const ABOUT_DATA = [
  'Тест создан на основе научных исследований лабораторией прикладного искусственного интеллекта, а ещё одобрен кандидатом психологических наук.',
  'Лучше понять свое истинное призвание? Получать удовольствие от работы? Данный тест поможет Вам определить области, на которые стоит обратить внимание для грамотного построения карьеры и профессионального развития.',
];

export const INTRO_PANELS_OPTIONS = [
  {
    title: 'Искусственный интеллект с научным подходом',
    text: ABOUT_DATA[0],
    buttonText: 'Далее'
  },
  {
    title: 'Хотите построить успешную карьеру?',
    text: ABOUT_DATA[1],
    buttonText: 'Узнать профессиональный тип'
  },
];
